import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const sanityClient = createClient({
  projectId: "1pnjifgm",
  dataset: "production",
  apiVersion: "2026-06-04",
  useCdn: false,
});

const builder = imageUrlBuilder(sanityClient);
export function urlFor(source) {
  return builder.image(source);
}
